import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
    selector: 'sy-toggle-button',
    template: `
    <mat-button-toggle-group [value]="initialValue" (change)="change.emit($event.value)" [ngClass]="cssClass" [multiple]="multiple" [disabled]="disabled" 
        [style.border-radius]="'calc(var(--button-toggle-pressed-border-radius) + 4px)'">
        <mat-button-toggle *ngFor="let item of items" [value]="item.value" [disableRipple]="true">
                <mat-icon *ngIf="item.icon as icon" class="material-symbols-outlined">{{icon}}</mat-icon>
                <div class="toggle-button-label" [custom-label]="item.label"></div>
            </mat-button-toggle>
        </mat-button-toggle-group>`,
    styles: [require('./servitly-toggle-button.component.css')]
})
export class ServitlyToggleButtonComponent {

    @Input() items: { label: string, value: any, icon?: string }[];

    @Input() initialValue: any;

    @Input() multiple: boolean;

    @Input() disabled: boolean;

    @Input() cssClass: string;

    @Output() change = new EventEmitter<any>
}


